import { stripInlineMarkdown } from "@/utils/inline-markdown";

/**
 * The adapter that turns a module's own axis fields into `ChartAxisFrame`
 * captions. It belongs here rather than in `components/charts/` because it
 * knows module data shapes, which the chart layer must not. The size budget for
 * chart modules lives in `@/config/layout`.
 */

export interface ModuleAxisLabelInput {
  xAxisLabel?: string;
  yAxisLabel?: string;
  xAxisUnit?: string;
  yAxisUnit?: string;
}

function axisCaptionText(label?: string, unit?: string): string | undefined {
  const name = stripInlineMarkdown(label).trim();
  if (!name) {
    return undefined;
  }
  return unit ? `${name} (${unit})` : name;
}

/**
 * Turns a chart module's raw axis-label props into `ChartAxisFrame` captions:
 * author text may carry inline markdown, and a unit is rendered as
 * `Label (unit)` rather than being written into the label itself.
 */
export function moduleAxisLabels({
  xAxisLabel,
  yAxisLabel,
  xAxisUnit,
  yAxisUnit,
}: ModuleAxisLabelInput): {
  xAxisLabel?: string;
  yAxisLabel?: string;
} {
  return {
    xAxisLabel: axisCaptionText(xAxisLabel, xAxisUnit),
    yAxisLabel: axisCaptionText(yAxisLabel, yAxisUnit),
  };
}
